import React, { useId } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './Modal.scss';

const cx = (...classes) => classes.filter(Boolean).join(' ');

export default function Modal({
  isOpen,
  title,
  children,
  footer,
  onClose,
  closeDisabled = false,
  showClose = true,
  canCloseOutside = false,
  size = 'md',
  className = '',
  bodyClassName = '',
  footerClassName = '',
  closeLabel = '닫기',
}) {
  const titleId = useId();

  if (!isOpen) return null;

  return (
    <div
      className="reops-modal-overlay"
      onClick={canCloseOutside && !closeDisabled ? onClose : undefined}
    >
      <section
        className={cx('reops-modal', `reops-modal--${size}`, className)}
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        onClick={(event) => event.stopPropagation()}
      >
        <header className="reops-modal__header">
          <h2 id={title ? titleId : undefined}>{title}</h2>
          {onClose && showClose ? (
            <button
              className="reops-modal__close"
              type="button"
              aria-label={closeLabel}
              disabled={closeDisabled}
              onClick={onClose}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          ) : null}
        </header>

        <div className={cx('reops-modal__body', bodyClassName)}>
          {children}
        </div>

        {footer ? (
          <footer className={cx('reops-modal__footer', footerClassName)}>
            {footer}
          </footer>
        ) : null}
      </section>
    </div>
  );
}
